
import { useWizardState } from './useWizardState';
import { useWizardNavigation } from './useWizardNavigation';
import { useWizardStepSubmit } from './useWizardStepSubmit';
import { useWizardSubmit } from './useWizardSubmit';
import { WizardFormData } from './types';

export const useProviderWizard = () => {
  const totalSteps = 6; // Including the summary step
  
  // Get wizard state and actions
  const [state, actions] = useWizardState();
  
  // Get wizard submission handler
  const { handleFinalSubmit } = useWizardSubmit(state, actions);
  
  // Get navigation handlers
  const { isLastStep, handleNext, handleBack, isStepValid } = 
    useWizardNavigation(state, actions, totalSteps, handleFinalSubmit);
  
  // Get step submission handler
  const { handleStepSubmit } = useWizardStepSubmit(state, actions, handleNext);

  return {
    currentStep: state.currentStep,
    formData: state.formData,
    isLastStep,
    totalSteps,
    isSubmitting: state.isSubmitting,
    handleNext,
    handleBack,
    handleStepSubmit,
    isStepValid
  };
};
